
























































import Vue from 'vue';
import { WOW } from 'wowjs';

export default Vue.extend({
	data() {
		return {
			publicPath: process.env.BASE_URL,
			bannerCarouse: 0,
			banners: [
				{
					title: 'GAMA Technology',
					text: 'All Inclusive total solution, professional system and interface development experience with our partner.',
					pic: require('../../static/images/Pic_Banner-2.jpg'),
				},
			],
			services: [
				{
					title: 'Financial Management Module',
					pic: require('../../static/images/Pic_Services-1.jpg'),
				},
				{
					title: 'Member Management Module',
					pic: require('../../static/images/Pic_Services-2.jpg'),
				},
				{
					title: 'Promotion/Marketing Management Module',
					pic: require('../../static/images/Pic_Services-3.jpg'),
				},
				{
					title: 'App Management Module',
					pic: require('../../static/images/Pic_Services-4.jpg'),
				},
				{
					title: 'Data Analysis Service',
					pic: require('../../static/images/Pic_Services-5.jpg'),
				},
				{
					title: 'Cloud Integration Service',
					pic: require('../../static/images/Pic_Services-6.jpg'),
				},
				{
					title: 'IT and Big-Data Consulting Service',
					pic: require('../../static/images/Pic_Services-7.jpg'),
				},
				{
					title: 'Third-Party Application Connect Service',
					pic: require('../../static/images/Pic_Services-8.jpg'),
				},
			],
		};
	},
	mounted() {
		this.$nextTick(() => {
			new WOW().init();
		});
	},
});
